export default {
	map: {},
	/**
	 * 获取依赖对象
	 * @author  韦胜健
	 * @date    2019/10/23 15:34
	 * @param   libName             string      依赖名称，可以从window.LinkLib.dependency中查找，该对象的key就是libName
	 * @return  object                          lib对象信息
	 */
	async getLib(libName) {
		const lib = window.LinkLib.dependency[libName]

		if (!lib) {
			throw new Error(`依赖库：${libName} 不存在！`)
		}

		if (!lib.js && !lib.css) {
			console.log(lib)
			throw new Error(`依赖库没有指定js以及css：${libName}`)
		}
		return lib
	},
	/**
	 * 加载依赖
	 * @author  韦胜健
	 * @date    2019/10/23 15:31
	 * @param   libName             string      依赖名称，可以从window.LinkLib.dependency中查找，该对象的key就是libName，注意资源加载完毕之后，返回的是window[libName]，所以LinkLib中dependency的key不是乱取的，而是资源加载完毕之后，从window对象中获取对象的key
	 * @return  object
	 */
	async loadLib(libName) {
		/*适配微前端*/
		if (!!window.MicroLib) {
			return window.MicroLib.load(libName)
		}

		const lib = await this.getLib(libName)
		const ret = []
		let version = !!lib.version ? `?version=${lib.version}` : ''
		if (!!lib.js) ret.push(this.load(lib.js + version))
		if (!!lib.css) ret.push(this.load(lib.css + version))
		await Promise.all(ret)
		return window[libName]
	},
	/**
	 * 加载依赖部分资源
	 * @author  韦胜健
	 * @date    2019/10/23 15:35
	 * @param   libName             string                  依赖名称
	 * @param   relativePath        string|Array<string>    部分依赖相对地址
	 * @return  void
	 */
	async loadLibPart(libName, relativePath) {
		/*适配微前端*/
		if (!!window.MicroLib) {
			return window.MicroLib.loadPart(libName)
		}

		const lib = await this.getLib(libName)

		if (!lib.basePath) {
			throw new Error(`依赖 ${libName} 没有basePath，无法加载部分资源`)
		}

		if (LinkVue.$utils.typeOf(relativePath) === 'string') {
			relativePath = [relativePath]
		}

		relativePath = relativePath.map(item => `${lib.basePath}/${item}`)
		return await this.load(relativePath)
	},
	/**
	 * 获取需要加载的url，如果url为http或者https开头，则不做处理，否则在前面拼接publicPath
	 * @author  韦胜健
	 * @date    2019/10/23 16:04
	 * @return  string                          // 格式化之后的url地址
	 */
	getUrl(url) {
		if (/^(http|https)/.test(url)) {
			return url
		} else {
			let publicPath = LinkVue.publicPath || ''
			const publicPathLen = publicPath.length
			if (publicPath.charAt(publicPathLen - 1) === '/') publicPath = publicPath.substring(0, publicPathLen - 1)
			if (url.charAt(0) === '/') url = url.substring(1, url.length)
			// console.log(`${publicPath === '/' ? '' : publicPath}/${url}`)
			return `${publicPath === '/' ? '' : publicPath}/${url}`
		}
	},
	/**
	 * 加载url资源
	 * @author  韦胜健
	 * @date    2019/10/23 16:05
	 * @param   urls                string|Array<string>        // 需要加载的资源的url地址
	 * @return  object|Array<object>
	 */
	load(urls) {
		urls = LinkVue.$utils.typeOf(urls) === 'array' ? urls : [urls]
		return Promise.all(urls.map(url => this._loadOne(url)))
	},
	/**
	 * 加载一个资源
	 * @author  韦胜健
	 * @date    2019/10/23 16:08
	 * @return  void
	 */
	async _loadOne(url) {
		if (this.map[url] === undefined) {
			this.map[url] = null
			this._loadResource(url)
			return await this._loadOne(url)
		} else {
			while (this.map[url] === null) {
				await LinkVue.$utils.delay(25)
			}
			return null
		}
	},
	/**
	 * 调用load.parallel，真正意义上的加载资源
	 * @author  韦胜健
	 * @date    2019/10/23 16:08
	 * @return  void
	 */
	_loadResource(url) {
		let method = url.indexOf('.js') > -1 ? 'js' : 'css'
		window.LazyLoad[method](this.getUrl(url), (flag) => {
			if (flag) {
				this.map[url] = true
				// console.log('load:', url)
			} else {
				console.error('load failed:', url)
			}
		}, true);

	},
}